import {type TeamMember, TeamMemberSchema} from "@mytour/shared";
import axios from "axios";
import {z} from "zod";

export const teamMemberApiService = {
  async getTeamMembers(): Promise<TeamMember[]> {
    const result = await axios.get("api/team/members/");
    return z.array(TeamMemberSchema).parse(result.data);
  },
};
